import React, { useRef } from "react";
import { Link, Outlet, useActionData, useSubmit } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { faFolderOpen, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function EmptyProject() {
  const fileImportButtonRef = useRef();
  const submit = useSubmit();
  const { csrfToken } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;
  const actionData = useActionData();

  // import project handler
  const importProject = (file) => {
    const reader = new FileReader();
    if (file) {
      reader.onload = (e) => {
        const contents = e.target.result;
        try {
          const importedProject = JSON.parse(contents);
          // initializeProjectData(importedProject);
          // navigate(`/import`);
          submit(
            { importedProject, csrfToken },
            {
              method: "post",
              // action: "/import",
              encType: "application/json",
            }
          );
        } catch {
          toast.error("Invalid JSON");
        }
      };
      reader.readAsText(file);
    }
  };

  return (
    <div className="w-50 position-absolute start-50 translate-middle-x pt-5">
      <div className="bg-purple reounded rounded-3 p-3">
        <div className="m-0">
          <Link
            className="btn btn-colored me-2"
            to="projects"
            title="Open a saved project"
          >
            <FontAwesomeIcon icon={faFolderOpen} className="me-2" /> Open
          </Link>
          <Link
            className="btn btn-colored"
            to="new/settings"
            title="Create a new project"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" /> New
          </Link>
          <input
            ref={fileImportButtonRef}
            className="d-none"
            onChange={(e) => importProject(e.target.files[0])}
            onClick={(e) => {
              e.target.value = null;
            }}
            type="file"
          />
          {/* <button
            type="button"
            title="Import from file"
            className="btn btn-outline-secondary btn-sm ms-1 border-0"
            onClick={() => fileImportButtonRef.current.click()}
          >
            <FontAwesomeIcon icon={icon({ name: "file-import" })} size="2xl" />
          </button> */}
        </div>
      </div>
      <div className="alert alert-warning mt-3">
        Open a project or create a new one
      </div>
      {actionData?.error && (
        <div className="alert alert-danger">{actionData?.error}</div>
      )}
      <Outlet />
    </div>
  );
}
